import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  useEffect(() => {
    if (!isOpen) return;
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-217">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 md:p-6" role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-218">
          {/* Backdrop */}
          <div className="absolute inset-0 bg-navy-900/70 backdrop-blur-sm" onClick={onClose} aria-hidden="true" data-id="element-219" />

          {/* Panel */}
          <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.97
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} className="relative bg-cream-50 rounded-2xl shadow-2xl w-full max-w-2xl max-h-[85vh] flex flex-col" data-id="element-220">
            {/* Header */}
            <div className="flex items-center justify-between gap-4 px-6 md:px-10 py-5 border-b border-cream-200" data-id="element-221">
              <h2 id="modal-title" className="font-serif text-2xl md:text-3xl text-navy-900 font-bold" data-id="element-222">
                {title}
              </h2>
              <button onClick={onClose} aria-label="Cerrar" className="shrink-0 w-10 h-10 rounded-full flex items-center justify-center text-charcoal-700 hover:bg-cream-200 transition-colors" data-id="element-223">
                <X className="w-5 h-5" data-id="element-224" />
              </button>
            </div>

            {/* Body */}
            <div className="overflow-y-auto px-6 md:px-10 py-6 text-charcoal-800 text-base md:text-lg leading-relaxed space-y-5" data-id="element-225">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}